import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import PersonalContactCard from '../../components/Person/PersonalContactCard';
import { messages } from './PersonalContacts.i18n';
import { loadPersonalContacts } from '../../redux/modules/personal-contacts/personal-contacts-middleware';
import AddContactButton from './Contact/AddContactButton';
import { setPersonalContactId } from '../../redux/modules/personal-contacts/personal-contacts-action-creator';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';
import history from '../../history';

class PersonalContacts extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      dispatch,
      patientId,
    } = this.props;

    if (patientId) {
      dispatch(
        callWithLoadingIndicator('PersonalContacts', () => dispatch(loadPersonalContacts(patientId))));
      dispatch(setPersonalContactId(null));
    }
  }

  handleEditContactClick = (contactId) => () => {
    this.props.dispatch(setPersonalContactId(contactId));
    history.push('/edit-contact');
  }

  sortPersonalContacts() {
    return this.props.personalContacts.sort((x, y) => {
      if (x.contactFirstName.toLowerCase() < y.contactFirstName.toLowerCase()) return -1;
      if (x.contactFirstName.toLowerCase() > y.contactFirstName.toLowerCase()) return 1;
      if (x.contactLastName.toLowerCase() < y.contactLastName.toLowerCase()) return -1;
      if (x.contactLastName.toLowerCase() > y.contactLastName.toLowerCase()) return 1;
      return 0;
    });
  }

  hasAddContactLink = () => {
    const { capabilitySetting } = this.props;
    const addContactLink = capabilitySetting && capabilitySetting.details ?
      !!capabilitySetting.details.find((x) => x.fieldName === 'AddContact') : false;
    return addContactLink;
  };

  renderPersonalContactCard = (contact, isDisplayAddContact, contactIndex) =>
    (<PersonalContactCard key={contactIndex.toString()} contact={ contact } editClick={this.handleEditContactClick}
      windowSize={this.props.windowSize} authorizeClick={this.handleEditContactClick}
      isDisplayAddContact={isDisplayAddContact}
    />);

  render() {
    const isDisplayAddContact = this.hasAddContactLink();
    return (
      <div data-qa-container="personalContactsContainer">
        <LoadingIndicatorContainer loadingKey="PersonalContacts" size="small">
          <div className="row">
              <div className="col-xs-12 personal-contact">
                <h2 tabIndex={0}><FormattedMessage {...messages.header} /></h2>
                { isDisplayAddContact ? <AddContactButton /> : null }
              </div>
          </div>
          <div className="row">
            { this.props.personalContacts.length > 0 ?
              this.sortPersonalContacts().map(
                (contact, contactIndex) => (
                  this.renderPersonalContactCard(contact, isDisplayAddContact, contactIndex)))
              :
            <div className="col-xs-12">
              <FormattedMessage {...messages.label.noContacts} />
            </div>}
          </div>
        </LoadingIndicatorContainer>
      </div>
    );
  }
}

PersonalContacts.propTypes = {
  dispatch: PropTypes.func,
  patientId: PropTypes.number,
  personalContacts: PropTypes.array,
  capabilitySetting: PropTypes.object,
  windowSize: PropTypes.string,
};

const mapStateProps = (state) => ({
  patientId: state.profile.patient.patientId,
  personalContacts: state.personalContacts.personalContacts,
  windowSize: state.window.size,
});

export default connect(mapStateProps)(PersonalContacts);